module.exports = {
          srcSet: __webpack_public_path__ + "3bf37dfd09832b234fa41ad88d835a9a-300.png"+" 300w",
          images:[ {path: __webpack_public_path__ + "3bf37dfd09832b234fa41ad88d835a9a-300.png",width: 300,height: 124}],
          src: __webpack_public_path__ + "3bf37dfd09832b234fa41ad88d835a9a-300.png",
          toString:function(){return __webpack_public_path__ + "3bf37dfd09832b234fa41ad88d835a9a-300.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAY0lEQVR4nC3OMQuCYBgE4AcaGoUkCAlDBRsEFxe3RgnCqc01+hFimz88PnhvuBvujjt4ocIFb9zQh5ZYcIA9UeCLGSN+6LDinszUyDCgxYYaDZ544JOCR5yRx8QVBU6Y4tr8B6vECEbUue6FAAAAAElFTkSuQmCC",
          width: 300,
          height: 124
        }